import {
  getList,
  getBoolean,
  getOptionalBoolean,
} from "@surya-digital/leo-ts-types";
import { ChildQuestionElementV1, ChildQuestionElementV1DTO, ChildQuestionElementV1Enums } from "./childQuestionElementV1";

export interface GroupWithChildQuestionsV1DTO {
  childQuestions: ChildQuestionElementV1DTO[];
  isUnanswered?: boolean | null;
}

export class GroupWithChildQuestionsV1 {
  readonly isGroupWithChildQuestionsV1GroupWithChildQuestionsV1: boolean = true;

  readonly childQuestions: ChildQuestionElementV1[];
  readonly isUnanswered: boolean | null;


  constructor(
  childQuestions: ChildQuestionElementV1[], 
  isUnanswered: boolean | null = null
  ) {
    this.childQuestions = childQuestions;
    this.isUnanswered = isUnanswered;
  }

  static fromDTO(dto: GroupWithChildQuestionsV1DTO): GroupWithChildQuestionsV1 {
    const childQuestions = getList<ChildQuestionElementV1DTO, ChildQuestionElementV1>(
      dto,
      "childQuestions",
      ChildQuestionElementV1.fromDTO,
      InvalidGroupWithChildQuestionsV1ChildQuestionsError
    );
    const isUnanswered = getOptionalBoolean(dto, "isUnanswered", InvalidGroupWithChildQuestionsV1IsUnansweredError);
    return new GroupWithChildQuestionsV1(
      childQuestions,
      isUnanswered
    );
  }

  toDTO(): GroupWithChildQuestionsV1DTO {
    const dto: GroupWithChildQuestionsV1DTO = {
        childQuestions: this.childQuestions.map((e: ChildQuestionElementV1) => { return e.toDTO() }),
    };
    if (this.isUnanswered !== undefined && this.isUnanswered !== null){
      dto.isUnanswered = this.isUnanswered;
    }
    return dto;
  }
  }

GroupWithChildQuestionsV1.prototype.toString = function toString(): string {
  return `GroupWithChildQuestionsV1(childQuestions='${this.childQuestions}',isUnanswered='${this.isUnanswered}')`;
};

export class InvalidGroupWithChildQuestionsV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupWithChildQuestionsV1Error";
  }
}
export class InvalidGroupWithChildQuestionsV1ChildQuestionsError extends InvalidGroupWithChildQuestionsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupWithChildQuestionsV1ChildQuestionsError";
  }
}

export class InvalidGroupWithChildQuestionsV1IsUnansweredError extends InvalidGroupWithChildQuestionsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupWithChildQuestionsV1IsUnansweredError";
  }
}
